var App = App || {};

window.allow_scroll = true;
window.allow_slide = true;
var scroll_status = 0;
var scroll_status2 = 0;
$(window).on('resize scroll', function () {
	if (window.allow_scroll) {
		var ix = 0;
		var top = 0
		$('.wtep').each(function () {
			top = $(this).attr('rel') == 1 ? 400 : 70;
			if ($(window).scrollTop() >= $(this).offset().top - top) ix = $(this).attr('rel');
		});
		if (is_plan && (ix == 2 || ix == 3)) {
		} else if (!$('body').hasClass('scr' + ix)) $('body').removeClass('scr0 scr1 scr2 scr3 scr4 scr5 scr6 scr15 scr16 scr17 scr18 scr19 scr20 scr21 scr22 scr23').addClass('scr' + ix);
		if (is_plan && (ix != 2 && ix != 3)) {
			$('#plan_drop').css({height: 0});
			$('#plan_name a.name').removeClass('name_on');
			is_plan = 0;
		}
	}
	if ($(window).scrollTop() > 0) {
		if (!scroll_status) {
			scroll_status = 1;
			$('#header').addClass('scr');
		}
	} else {
		if (scroll_status) {
			scroll_status = 0;
			$('#header').removeClass('scr');
		}
	}
	if ($(window).scrollTop() > 800) {
		if (!scroll_status2) {
			scroll_status2 = 1;
			$('#header').addClass('scr2');
		}
	} else {
		if (scroll_status2) {
			scroll_status2 = 0;
			$('#header').removeClass('scr2');
		}
	}
});


$(document).ready(function () {
	window.setTimeout(function () {
		$(window).trigger('scroll');
		$(window).trigger('resize');
	}, 300);

	// Start onload page effects
	window.setTimeout(function () {
		$('body').removeClass('load0s').addClass('loaded');
	}, 100);
	window.setTimeout(function () {
		$('body').removeClass('load1s');
	}, 1000);
	window.setTimeout(function () {
		$('body').removeClass('load2s');
	}, 2000);
	window.setTimeout(function () {
		$('body').removeClass('load3s');
	}, 3000);

	if (is_retina()) {
		$('img[data-src]').not('.retina').addClass('retina').each(function () {
			$(this).attr('src', $(this).attr('data-src'));
		});
	}
});
var is_drop = 0;
var is_plan = 0;
var is_type = 0;
var is_menu = 0;
var is_lang = 0;

function listenClicks(evt) {
	if (!is_drop && !is_menu && !is_lang && !is_plan && !is_type) return true;
	evt = (evt) ? evt : ((event) ? event : null);
	if (evt) {
		el = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
		if (el.className && el.className.indexOf('pointer') != -1) return;
		if (is_drop && (el.className && el.className == 'dropmenu')) return;
		if (is_plan && (el.id && (el.id == 'plan_drop' || el.id == 'plan_name'))) return;
		if (is_type && (el.id && (el.id == 'client_switch' || el.id == 'client_types'))) return;
		while (el.parentNode) {
			el = el.parentNode;
			if (is_drop && (el.className && el.className == 'dropmenu')) return;
			if (is_plan && (el.id && (el.id == 'plan_drop' || el.id == 'plan_name'))) return;
			if (is_type && (el.id && (el.id == 'client_switch' || el.id == 'client_types'))) return;
		}
		if (is_drop) {
			$('.dropmenu').hide();
			is_drop = 0;
		} else if (is_menu) {
			is_menu = 0;
		} else if (is_lang) {
			is_lang = 0;
		} else if (is_plan) {
			$('#plan_name a').trigger('click');
			is_plan = 0;
		} else if (is_type) {
			$('#client_switch').trigger('click');
			is_type = 0;
		}
	}
}

$(document).on('mousedown', listenClicks);

/*------------buttons----------*/
function print_icon(obj) {

	$(obj).blur();
	window.print();

}

function scrolltop_icon() {
	$('html,body').animate({scrollTop: 0}, 1000, function () {
		window.allow_scroll = true;
		$(window).trigger('scroll');
		$('body').removeClass('do_scrolling');
	});
}

function share_icon(obj) {
	if (obj.dataset.link) history.pushState(null, null, obj.dataset.link);
	if ($('#copy_link').data('title')) {
		$('#copy_link').html($('#copy_link').data('title'));
	}
	$('article.item_act').removeClass('item_act');
	var drop2menu = $('#drop2menu');
	var article = obj.closest('article');
	if (article) {
		$(article).addClass('item_act');
		if (drop2menu.hasClass('copy_hash')) {
			history.pushState(null, null, '#' + article.id);
		} else {
			var id = $(article).attr('rel'),
				a = $('#blog_right #ba' + id + ' a');
			if (a.length && a.attr('href')) {
				history.pushState(null, null, a.attr('href'));
			}
		}
	}
	dropmenu(obj, 'right', drop2menu[0], '');
}

// landing rules

$(document).ready(function() {
	if ($('body').hasClass('bd_landing')) {
		$('#header .menu li[data-scroll-to] a').on('click', function() {
			$([document.documentElement, document.body]).animate({
				scrollTop: $('#blocks div[data-block="'+$(this).parent().attr('data-scroll-to')+'"]').offset().top - $('#header').height()
			}, 800);
			return false;
		});
		$('#header .name a, #header a.logo').on('click', function() {
			$('html,body').stop().animate({scrollTop: 0}, 500, 'swing');
			return false;
		});
		//$('#footer-dark .f-center').appendTo('#footer-dark .f-bottom').insertAfter('#footer-dark .f-bottom .f-bottom-left');
	} else {
		$('#header .name a, #header a.logo').on('click', function() {
			// App.blog.show();
			// return false;
		});
	}
});

$(document).ready(function() {
	let elements = document.querySelectorAll('[data-btn-event]');
	elements.forEach(element => {
		element.addEventListener('mousedown', function() {
			const event_type = this.getAttribute('data-btn-event');
			if (event_type) ga_reg_block_click(event_type);
		});
	});
});

$(document).ready(function(){
	function onElementAdded(element) {
		let iframe = $(element).find('iframe').get(0);
		if (iframe) {
			let iframeHead = $(iframe.contentWindow.document).find("head");
			iframeHead.append('<link rel="stylesheet" href="/assets/css/vendor/ringostat.css" />');
			setTimeout(function (){ $('#wrapper_id').css({'opacity': 1});}, 300);
		}
	}

	if ( $('body').hasClass('logged') && typeof Intercom !== 'undefined' ) {
		Intercom('update', {
			"hide_default_launcher": true
		});
	}

	let observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			mutation.addedNodes.forEach(function(node) {
				if (node.nodeType === 1 && node.id === 'wrapper_id') {
					onElementAdded(node);
				}
				if (node.nodeType === 1 && node.classList.contains('rngst_phone_button')) {
					let now = new Date();
					let hour = now.getHours();
					//if (hour < 10 || hour > 17 || window.location.href.includes('support.html')) $(node).hide();
				}
			});
		});
	});

	let config = { childList: true, subtree: true };

	observer.observe(document.body, config);
});
;function init_anchors() {
	$('a[href*="#"]:not([href="#"])').not('.anch_init').addClass('anch_init').click(function () {
		let isIos = navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/);
		if (window.innerWidth <= 700 && $('body').hasClass('scr13')) {
			return false;
		}
		if (location.search.replace(/#.*/, '') == this.search.replace(/#.*/, '') && location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
			if ($target.length) {
				history.replaceState(null, null, this.hash);
				var targetOffset = $target.offset().top - $('#header').outerHeight();
				if (this.hash == '#comment') {
					window.setTimeout(function () {
						$('#comment_text').click().focus();
					}, isIos ? 100 : 1200);
				}
				window.allow_scroll = false;
				$('body').addClass('do_scrolling');
				if ($('body').hasClass('page-partner')) {
					$('.partnerContent').animate({scrollTop: targetOffset}, 1000, function () {
						window.allow_scroll = true;
						$(window).trigger('scroll');
						$('body').removeClass('do_scrolling');
					});
					return false;
				}
				if (isIos) {
					window.scrollTo(0, targetOffset);
					window.allow_scroll = true;
					$(window).trigger('scroll');
					$('body').removeClass('do_scrolling');
				} else {
					$('html,body').animate({scrollTop: targetOffset}, 1000, function () {
						window.allow_scroll = true;
						$(window).trigger('scroll');
						$('body').removeClass('do_scrolling');
					});
				}

				return false;
			}
		}
	});
}

$(document).on('ready dataload', init_anchors);
;

function appinit() {}
var keyboard_is_on = false;
function app_keyboard(on) {
	keyboard_is_on = on;
	if (on) {
		$('body').addClass('w_keyboard');
		if ($('#TB_window').length) $(window).scrollTop(0);
	} else {
		$('body').removeClass('w_keyboard');
		app_redraw();
	}
}
function app_redraw() {
	$(window).scrollTop($(window).scrollTop());
}
var kb_height = 0;
function app_keyboard_height(kh) {
	kb_height = kh;
	comment_form.onresize();
	if (kh && $('body').hasClass('modal480com')) {
		setTimeout(function() {$(window).scrollTop(0);}, 1);
	}
}
(function(w){if(!w._cdvMessageHandler) {w._cdvMessageHandler = function(id,d){w.webkit.messageHandlers.cordova_iab.postMessage({d:d, id:id});}}})(window)
function app_navigator(url) {
	if (document.location.href === url) url += '#' + Math.round(Math.random()*1000);
	document.location.href = url;
}

function app_send_event(event) {
	if (is_app()) {
		if (typeof event == 'string') event = {msg: event};
		if (window.webkit && window.webkit.messageHandlers) {
			window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(event))
		}
	}
}
function app_get_event() {
	return localStorage.getItem('app_action')
}
function app_clear_event() {
	localStorage.setItem('app_action', '')
}
function app_on_resume() {

}

// ------------------------------------------------------------------------------------------------------------------------------------------------------------------

$(document).ready(function() {
	appinit();
});
;var touch_qslider_x = -1,
	touch_qslider_y = -1,
	touch_qslider_t = -1;

$(document).ready(function () {

	$('.quote_slider_list').on('mousedown touchstart', function (e) {

		clone_blockquote();
		let el = $(this).find('blockquote:first');
		$(this).css({cursor: 'grabbing'}).data({
			'start': 0,
			'width': el.outerWidth() + parseInt(el.css('marginLeft')) + parseInt(el.css('marginRight')),
			'left': parseInt($(this).css('left'))
		}).addClass('animateNone');

		var touch = e;
		if (e.type == 'touchstart') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
		}
		touch_qslider_x = touch.pageX;
		touch_qslider_y = touch.pageY;
		touch_qslider_t = 0;

		$('body').on('mousemove touchmove mouseup mouseleave touchend touchcancel', slider_scroll);

	});

	$('.quote_slider_list').on('transitionend', clone_blockquote);

});

function slider_scroll(e) {

	if (touch_qslider_t == 1 || touch_qslider_x == -1) return; // top-botom
	if (touch_qslider_t == 2) e.preventDefault(); // left-right
	if (touch_qslider_t == -1) return; // for mouse
	var touch = e;
	if (e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
		var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
	}
	this_x = touch.pageX;
	this_y = touch.pageY;
	if (touch_qslider_t == 0) {
		if (Math.abs(this_x - touch_qslider_x) > Math.abs(this_y - touch_qslider_y) + 2) {
			touch_qslider_t = 2;
			e.preventDefault();
		} else if (Math.abs(this_x - touch_qslider_x) + 2 < Math.abs(this_y - touch_qslider_y)) {
			touch_qslider_t = 1;
			return;
		} else {
			return;
		}
	}

	var qslist = $('.quote_slider_list');
	qslist.css({left: (qslist.data('left') + (this_x - touch_qslider_x)) + 'px'});

	let pix = 50;
	if (e.type !== 'mouseup' && e.type !== 'touchend' && e.type !== 'touchcancel') {
		pix = qslist.data('width') * (1 + qslist.data('start'));
	}

	if (this_x - touch_qslider_x > pix) {
		qslist.data({'start': qslist.data('start') + 1, 'clone': 'last'});
	} else if (touch_qslider_x - this_x > pix) {
		qslist.data({'start': qslist.data('start') + 1, 'clone': 'first'});
	}

	if (e.type === 'mouseup' || e.type === 'mouseleave' || e.type === 'touchend' || e.type === 'touchcancel') {

		touch_qslider_t = touch_qslider_y = touch_qslider_x = -1;
		var qslist = $('.quote_slider_list');
		qslist.removeClass('animateNone').css({cursor: 'grab'});

		if (qslist.data('start')) {
			var offset = qslist.data('width');
			if (qslist.data('clone') != 'first') offset = -offset;
			qslist.css({'left': (parseInt(qslist.data('left')) - qslist.data('start') * offset) + 'px'});
		} else {
			qslist.css({'left': '0px'});
		}
		$('body').off('mousemove touchmove mouseup mouseleave', slider_scroll);
	}

}

function clone_blockquote() {
	touch_qslider_t = touch_qslider_y = touch_qslider_x = -1;

	var qslist = $('.quote_slider_list');
	if (!qslist.data('start')) return true;

	qslist.addClass('animateNone').css({left: 0, cursor: 'grab'});
	for (let i = 0; i < qslist.data('start'); i++) {
		if (qslist.data('clone') == 'first') {
			qslist.find('blockquote:first').clone().appendTo(qslist);
		} else {
			qslist.find('blockquote:last').clone().prependTo(qslist);
		}
		qslist.find('blockquote:' + qslist.data('clone')).remove();
	}
	qslist.removeData('clone').data({'start': 0});

	let quoteIds = {};

	qslist.find('blockquote[data-quote-id]').each(function() {
		let quoteId = $(this).data('quote-id');
		if (quoteIds[quoteId]) {
			$(this).remove();
		} else {
			quoteIds[quoteId] = true;
		}
	});

}
;var last_dropmenu = null;
var last_dropmenu_box = null;
var last_dropmenu_type = 0;
var is_dropopen = false;
var last_dropscroll = 0;

function drophide(doit) {
	if (window.ignore_drophide) return;
	window._keytrack = false;
	window._mkeytrack = false;
	$('body').removeClass('body_wmenu');
	if (!last_dropmenu) return;
	if (!last_dropmenu_box) last_dropmenu_box = $ID(last_dropmenu.id + 'menu');
	//if ($(window).width() <= 480) { $(window).scrollTop(last_dropscroll); doit = true; }
	if (doit) $(last_dropmenu_box).hide(); else $(last_dropmenu_box).fadeOut();
	if (window.loader_tm) window.clearTimeout(window.loader_tm);
	$(last_dropmenu).removeClass('eye_act norm_act drop_over drop_open ico_dots_act dropmaster_over').parent().removeClass('icons_act');
	last_dropmenu = null;
	last_dropmenu_box = null;
	last_dropmenu_type = 0;
}

var dropreturn = '';

// TODO: this part is taken of account section. Need cleanup

function dropmenu(el, type_pos, el2, droptitle) {
	if (!type_pos) type_pos = '';
	if (type_pos.indexOf('text') == -1) el.blur();
	if (typeof el2 != 'undefined' && el2) el2 = $(el2).get(0);
	else el2 = $('#' + el.id + 'menu').get(0);
	if (last_dropmenu && last_dropmenu != el) {
		drophide(true);
	}
	last_dropmenu = el;
	last_dropmenu_box = el2;
	last_dropmenu_type = 0;
	if ($(el2).is(":hidden")) {
		//last_dropscroll = $(window).scrollTop();
		is_dropopen = true;
		if (type_pos.indexOf('static') != -1) {
			$(el2).fadeIn(200);
		} else {
			var ds = {};
			var ds2 = {};
			ds['position'] = type_pos.indexOf('fixed') != -1 || type_pos.indexOf('mymenu') != -1 ? 'fixed' : 'absolute';
			if (type_pos.indexOf('text') == -1) $(el2).removeClass('dropmenu_ha'); else $(el2).addClass('dropmenu_ha');
			var ds_el = type_pos.indexOf('parent3') != -1 ? $(el).parent().parent().parent() : (type_pos.indexOf('parent2') != -1 ? $(el).parent().parent() : (type_pos.indexOf('parent') != -1 ? $(el).parent() : $(el)));

			// -----------------------------------
			if (!$(el2).find('.drophead').length) $(el2).prepend('<div class="drophead"></div>')
			if (!$(el2).find('.esc').length) {
				$(el2).find('.drophead').prepend('<span onclick="drophide()" class="esc esc_nm button button_sm button_trans">esc</span><span onclick="drophide()" class="ico ico_r ico_esc"></span>')
			}
			$(el2).find('.drophead').removeClass('drophead_wr').find('.ico_left3').remove();
			if (dropreturn) {
				$(el2).find('.drophead').addClass('drophead_wr').prepend('<span onclick="drophide(true); $(' + (dropreturn == 'last' ? 'last_dropreturn' : '\'' + dropreturn + '\'') + ').trigger(\'click\')" class="ico ico_l ico_left3"></span>')
				dropreturn = '';
			}
			$(el2).find('.group_ignore').removeClass('group_ignore');
			$(el2).find('.set_group_ignore').addClass('group_ignore').removeClass('set_group_ignore');
			if ($(el).attr('data-notitle') || type_pos.indexOf('priority') != -1 || type_pos.indexOf('notitle') != -1) {
			} else if (droptitle || $(el).attr('title') || $(el).parent().find('a.b').length) {
				if (!droptitle) droptitle = $(el).attr('title') ? $(el).attr('title') : ($(el).attr('data-title') ? $(el).attr('data-title') : $(el).parent().find('a.b').text());
				if (!$(el2).find('.droptitle').length) {
					$(el2).find('.drophead').append('<span class="droptitle">' + droptitle + '</span>')
				} else if (!$(el2).hasClass('fixtitle')) {
					$(el2).find('.droptitle').html(droptitle);
				}
			}
			// -----------------------------------
			if (type_pos.indexOf('left') != -1 || type_pos.indexOf('width') != -1) {
				ds['left'] = ds_el.offset().left - 7;
				if (ds['position'] == 'fixed') ds['left'] -= $(window).scrollLeft();
				if (ds['left'] <= 5) ds['left'] = 5;
				$(el2).addClass('dropmenu_l');
			} else {
				ds['left'] = ds_el.offset().left + ds_el.outerWidth() + 7;
				if (ds['position'] == 'fixed') {
					ds['left'] -= $(window).scrollLeft();
					ds['left'] = Math.min(ds['left'], $(window).width() - 5);
				}
				$(el2).removeClass('dropmenu_l');
			}
			if (type_pos.indexOf('bottom') != -1 && $(window).width() > 480) {
				ds['top'] = Math.floor(ds_el.offset().top + ds_el.outerHeight() / 2 + 25);
				if (ds['position'] == 'fixed') {
					ds['top'] = Math.min(ds['top'], $(window).height() - 5);
				}
				$(el2).addClass('dropmenu_b');
			} else if (type_pos.indexOf('abstop') != -1) {
				ds['top'] = Math.floor(ds_el.offset().top - 5);
				if (ds['top'] <= 5) ds['top'] = 5;
				$(el2).removeClass('dropmenu_b');
			} else {
				ds['top'] = Math.floor(ds_el.offset().top + ds_el.outerHeight() / 2 - 25);
				if (ds['top'] <= 5) ds['top'] = 5;
				$(el2).removeClass('dropmenu_b');
			}
			if (type_pos.indexOf('width') != -1 || type_pos.indexOf('min_wid') != -1) {
				ds2['width'] = ds_el.outerWidth() - 10;
				if (ds2['width'] <= 320) $(el2).addClass('dropmenu_l400'); else $(el2).removeClass('dropmenu_l400');
			}
			$(el2).css(ds2).appendTo('#dropmenu_place').show();
			ds['zIndex'] = $(el2).css('zIndex');
			$('#dropmenu_place').css(ds);
		}
		$('body').addClass('body_wmenu');
		$(el).addClass('drop_open');
	}
}
;function bind_effects() {
	$('.ani_wait').each(function () {
		if ($(this).offset().top - $(window).scrollTop() > $(window).height() - 80) $(this).addClass('ani_bind ani_work');
		$(this).removeClass('ani_wait');
	});
}

function bind_effects2() {
	if ($('#blocks h1.rotate').length) {
		$('#blocks h1.rotate').removeClass('rotate_init').html('<span>' + $('#blocks h1.rotate').html() + '<font>' + $('#blocks h1.rotate').html() + '</font></span>');
		setInterval(function () {
			let o = $('#blocks h1.rotate').removeClass('fade');
			let i = o.attr('data-i');
			let arr = o.attr('data-titles').split('|');
			i++;
			if (i >= o.attr('data-n')) i = 0;
			str_typewriter = arr[i].replace(/<[^>]+>/, "\t").replace('&nbsp;', ' ').split("\t");
			o.attr('data-i', i).html('<span>' + arr[i] + '<font>' + arr[i] + '</font></span>').find('font b').addClass('col' + Math.floor(Math.random() * 8)).each(function () {
				$(this).attr('data-txt', $(this).text()).text('');
				setTimeout(function () {
					title_typewriter();
				}, 400);
				setTimeout(function () {
					// title_typewriter_back();
					$('#blocks h1.rotate').addClass('fade');
				}, 5400);
			});
		}, 6000);
		setTimeout(function () {
			// title_typewriter_back();
			$('#blocks h1.rotate').addClass('fade');
		}, 5400);
	}
}

function title_typewriter() {
	let o = $('#blocks h1.rotate font b');
	let txt = o.attr('data-txt');
	if (txt.length) {
		o.text(o.text() + txt[0]).attr('data-txt', txt.substring(1));
		setTimeout(title_typewriter, 50);
	}
}

function title_typewriter_back() {
	let o = $('#blocks h1.rotate b:last');
	let txt = o.text();
	if (txt.length > 0) {
		txt = txt.substring(0, txt.length - 1);
		o.text(txt);
		setTimeout(title_typewriter_back, 50);
	}
}

function run_effects() {
	$('.ani_work').each(function () {
		let el_off = $(this).attr('data-effect-offset') ? 1 * $(this).attr('data-effect-offset') : 0;
		if ($(this).offset().top + el_off - $(window).scrollTop() < $(window).height() - 80) $(this).removeClass('ani_work').addClass('ani_start');
	});
	if (!window.eff_binded && $(window).scrollTop() > 250) {
		window.eff_binded = true;
		bind_effects2();
	}
}

$(document).ready(bind_effects);
$(window).on('scroll', run_effects);

;$.fn.dropZoneInit = function () {
	if (typeof (window.FileReader) == 'undefined') {
		$(this).find('span.droplink').remove();
		return false;
	}
	$(this).off('drop').on('dragenter', function (e) {
	}).on('dragover', function (e) {
		$(this).addClass('drop-hover');
		return false;
	}).on('dragleave', function (e) {
		$(this).removeClass('drop-hover');
	}).on('drop', function (e) {
		event = e.originalEvent;
		event.preventDefault();
		var file = event.dataTransfer.files;
		for (var i = 0; i < file.length; i++) upload_drop_file(file[i]);
		$(this).removeClass('drop-hover');
		$('.drop-zone').removeClass('drop-zhover');
		$('body').removeClass('body_drop body_dropm');
		return false;
	});
	$('.drop_zone').on('click', function () {
		$('.drop-hover').removeClass('drop-hover');
		$('body').removeClass('body_drop body_dropm');
	});
	return false;
}

// ------------------------------------------------------------------------------------------------------------------------------------------------------------------

var num_attach = 0;

function add_attach() {
	num_attach++;
	var p = $('#all_attach');
	var o = p.find('.attachmulty:first').clone();
	o.attr('id', 'attach' + num_attach).appendTo(p);
	o.find('input[type=file]').on('change', bind_attachments);
	try {
		o.find('input[type=file]').trigger('click');
	} catch (e) {
		o.show();
	}
}

function upload_clipboard_file(file, file_name) {
	num_attach++;
	var fd = new FormData;
	fd.append('action', 'upload');
	fd.append('mda', $('#def_mda').val());
	fd.append("ufile[]", file);
	fd.append("ufile_name[]", file_name);
	var xhr = new XMLHttpRequest();
	xhr.number = num_attach;
	xhr.upload.addEventListener('loadstart', function () {
		ext_arr = file_name.split('.');
		var p = $('#all_attach');
		p.show().append('<div id="attach' + num_attach + '"><div class="attach"><span class="loader_sm loadingimg"></span><span class="sm_ext sm_ext_' + ext_arr[ext_arr.length - 1].toLowerCase() + '">' + file_name + '</span><u></u><span class="sm_prog_"><span class="sm_prog sm_ext_' + ext_arr[ext_arr.length - 1].toLowerCase() + '"></span></span></div></div>');
		num_attachments()
	});
	xhr.onreadystatechange = function () {
		if (xhr.readyState != 4) return
		$('#attach' + xhr.number).html(xhr.responseText);
		window.wait_submit--;
		if (window.wait_submit < 1) $('body').removeClass('mouse_v2');
	};
	window.wait_submit++;
	$('body').addClass('mouse_v2');
	xhr.open('POST', document.sup_form ? $(document.sup_form).attr('action') : '/en/support.html', true);
	xhr.setRequestHeader('x-load-type', 'ajax');
	xhr.send(fd);
}

var upload_form_data = [];
var upload_started = false;

function upload_start() {
	if (upload_started) return false;
	if (upload_form_data.length == 0) return false;
	upload_started = true;
	fd = upload_form_data.shift();

	var xhr = new XMLHttpRequest();
	xhr.upload.num = xhr.num = fd.num;
	prefix = '#attach';
	// xhr.upload.addEventListener('loadstart',function() {});
	xhr.upload.addEventListener("progress", function (e) {
		var pc = parseInt(e.loaded / e.total * 100);
		// $('#attach' + this.num + ' .sm_ext').html(pc + "%");
		$('#attach' + this.num + ' .sm_prog').css({width: (100 - pc) + "%"});
	}, false);
	xhr.onreadystatechange = function () {
		if (xhr.readyState != 4) return;
		$('#attach' + this.num).html(xhr.responseText);
		window.wait_submit--;
		if (window.wait_submit < 1) $('body').removeClass('mouse_v2');
		upload_started = false;
		upload_start();
	};
	xhr.open('POST', document.sup_form ? $(document.sup_form).attr('action') : '/en/support.html', true);
	xhr.setRequestHeader('x-load-type', 'ajax');
	xhr.send(fd);
}

function upload_drop_file(file) {
	if (file.size > 100 * 1024 * 1024) {
		var p = $('#all_attach');
		ext_arr = file.name.split('.');
		p.append('<div class="attach file_opac"><span class="sm_ext sm_ext_' + htmlenc(ext_arr[ext_arr.length - 1].toLowerCase()) + '">Too big: ' + htmlenc(file.name) + '</span><u></u></div>');
		return false;
	}
	num_attach++;
	var fd = new FormData;
	fd.append('action', 'upload');
	fd.append('mda', $('#def_mda').val());
	fd.append("ufile[]", file);
	fd.num = num_attach;
	upload_form_data.push(fd);

	window.wait_submit++;
	$('body').addClass('mouse_v2');
	var p = $('#all_attach');

	ext_arr = file.name.split('.');
	p.show().append('<div id="attach' + num_attach + '"><div class="attach"><span class="loader_sm loadingimg"></span><span class="sm_ext sm_ext_' + htmlenc(ext_arr[ext_arr.length - 1].toLowerCase()) + '">' + htmlenc(file.name) + '</span><u></u><span class="sm_prog_"><span class="sm_prog sm_ext_' + ext_arr[ext_arr.length - 1].toLowerCase() + '"></span></span></div></div>');
	num_attachments();

	upload_start();
}

function num_attachments() {
	if ($('#all_attach .attach').not('.file_opac').length) {
		$('#all_attach').show();
	} else {
		$('#all_attach').hide();
	}
}

function _after_attachments(el) {
	if (!/empty/.test(el.contentWindow.location.href)) {
		$('#' + $(el).attr('id').replace(/^af/, '')).show().removeClass('attachmulty').html(el.contentWindow.document.body.innerHTML);
		num_attachments();
		window.wait_submit--;
		if (window.wait_submit < 1) $('body').removeClass('mouse_v2');
		history.go(-1);
	}
}

function bind_attachments() {
	if (typeof (window.FileReader) != 'undefined' && this.files) {
		for (var i = 0; i < this.files.length; i++) upload_drop_file(this.files[i]);
		$(this).attr('disabled', true);
		return false;
	}
	$('af' + $(this).parent().attr('id')).remove();
	$(this).parent().show().append('<iframe name="af' + $(this).parent().attr('id') + '" src="/empty/" width="1" height="1" style="visibility:hidden; position:relative;left: 0px;top: -1px" scrolling="auto" frameborder="0" id="af' + $(this).parent().attr('id') + '" onload=" _after_attachments(this);" class="loadingimg"></iframe>');
	$('.attachmulty input[type=file]').add($(this.form).find('textarea')).attr('disabled', true);
	$(this).attr('disabled', false);
	frm_bak = [this.form.target, this.form.action, this.form.elements['action'].value, this.form.elements['mda'].value];
	this.form.target = 'af' + $(this).parent().attr('id');
	this.form.action = document.sup_form ? $(document.sup_form).attr('action') : '/en/support.html';
	this.form.elements['action'].value = 'upload';
	this.form.elements['mda'].value = $('#def_mda').val();
	this.form.submit();
	window.wait_submit++;
	$('body').addClass('mouse_v2');
	$('.attachmulty input[type=file]').add($(this.form).find('textarea')).attr('disabled', false);
	$(this).attr('readonly', true);
	$(this).parent().append(' <span class="loader_sm loadingimg"></span>');
	this.form.target = frm_bak[0];
	this.form.action = frm_bak[1];
	this.form.elements['action'].value = frm_bak[2];
	this.form.elements['mda'].value = frm_bak[3];
}

// ------------------------------------------------------------------------------------------------------------------------------------------------------------------

var drop_tm;
var drag_started = false;
$(document).ready(function () {
	$('#dz-left').dropZoneInit();
	num_attachments();
	if (typeof (window.FileReader) != 'undefined') $(document).on('dragstart', function () {
		window.skip_dragupload = 1;
	}).on('dragend', function () {
		window.skip_dragupload = 0;
	}).on('dragenter', function (e) {
		if (window.skip_dragupload) return false;
		$('.drop-zone').addClass('drop-zhover');
		$('body').addClass('body_drop');
		setTimeout(function () {
			if (drop_tm) clearTimeout(drop_tm);
		}, 1);
		return false;
	}).on('dragleave', function (e) {
		if (drop_tm) clearTimeout(drop_tm);
		drop_tm = setTimeout(function () {
			$('.drop-zone').removeClass('drop-zhover');
			$('body').removeClass('body_drop body_dropm');
		}, 20);
		return false;
	}).on('dragover', function (e) {
		var dt = e.originalEvent.dataTransfer;
		dt.dropEffect = 'none';
		return false;
	});
	$('.drop_zone').on('click', function () {
		$('.drop-hover').removeClass('drop-hover');
		$('body').removeClass('body_drop body_dropm');
	});

	$('.attach input[type=file]').on('change', bind_attachments);
	$('.attachmulty input[type=file]').on('change', bind_attachments);
});
;function checkForm(frm, arr, mes) {
	if (!frm || !frm.elements) {
		alert('Форма не определена');
		return false;
	}
	//if (cf_submitted[frm.name]) return false;
	el = null;
	err = '';
	var j = '';
	var m = '';
	for (var i in arr) {
		j = '';
		m = arr[i];
		if (/^([a-zA-Z01-9_]+)\|([a-zA-Z01-9_]+)$/.test(i)) {
			i = RegExp.$1;
			j = RegExp.$2;
		}
		if (frm.elements[i])
			switch (frm.elements[i].type) {
				case 'text':
				case 'textarea':
				case 'password':
				case 'hidden':
				case 'file':
				case 'email':
					if ((!/\S/.test(frm.elements[i].value) || frm.elements[i].value == '0') && (!j || frm.elements[j].value == '' || frm.elements[j].value == '0')) {
						if (!el) el = frm.elements[i];
						err += m + "\n";
					} else if ((i == 'email') && (!/^[^@]+@[^@]+$/.test(frm.elements[i].value))) {
						if (!el) el = frm.elements[i];
						err += m + ' | Формат: email@somethere.org' + "\n";
					}
					break;
				case 'select-one':
					if ((frm.elements[i].value == '' || frm.elements[i].value == '0') && (!j || frm.elements[j].value == '' || frm.elements[j].value == '0')) {
						if (!el) el = frm.elements[i];
						err += m + "\n";
					}
					break;
			}
	}
	if (err == '') {
		//cf_submitted[frm.name] = 1;
		frm.onsubmit = function () {
			return false;
		}
		window.allowpresave = false;
		return true;
	} else {
		try {
			el.focus();
		} catch (e) {
		}
		if (!mes) mes = 'Пожалуйста заполните обязательные поля';
		alert(mes + ":\n---------------------------------------------\n" + err + "---------------------------------------------");
		return false;
	}
}

function checkForm_old(frm, arr, mes) {
	if (!frm || !frm.elements) {
		alert('Форма не определена');
		return false;
	}
	el = null;
	err = '';
	for (i in arr) {
		if (frm.elements[i])
			switch (frm.elements[i].type) {
				case 'text':
				case 'textarea':
				case 'password':
				case 'hidden':
					if (frm.elements[i].value == '' || frm.elements[i].value == '0') {
						if (!el) el = frm.elements[i];
						err += arr[i] + "\n";
					} else if ((i == 'email') && (!/^[^@]+@[^@]+$/.test(frm.elements[i].value))) {
						if (!el) el = frm.elements[i];
						err += arr[i] + ' | Формат: email@somethere.org' + "\n";
					}
					break;
				case 'select-one':
					if (frm.elements[i].selectedIndex == 0) {
						if (!el) el = frm.elements[i];
						err += arr[i] + "\n";
					}
					break;
			}
	}
	if (err == '') return true;
	else {
		try {
			el.focus();
		} catch (e) {
		}
		if (!mes) mes = 'Пожалуйста заполните обязательные поля'
		alert(mes + ":\n-----------------------------------\n" + err + "-----------------------------------");
		return false;
	}
}
;$(document).ready(function () {
	$('.langSwitcher__select').on('change', langSwitcherSelect);
	$(document).on('keyup', function (event) {
		if (event.altKey) {
			let redirect = '';
			if (event.which == 49) {
				redirect = window.location.pathname.replace(/^\/(en\/|ua\/)?/i, "/");
			} else if (event.which == 50) {
				redirect = window.location.pathname.replace(/^\/(en\/|ua\/)?/i, "/ua/");
			} else if (event.which == 51) {
				redirect = window.location.pathname.replace(/^\/(en\/|ua\/)?/i, "/en/");
			}
			if (redirect) {
				document.location.href = redirect + window.location.search + '#scrollTop=' + $(window).scrollTop();
			}
		}
	});
	if (window.location.hash && window.location.hash.includes("#scrollTop")) {
		let start = window.location.hash.indexOf('=');
		$(window).scrollTop(window.location.hash.slice(1 + start));
		history.pushState("", document.title, window.location.pathname + window.location.search);
	}
});

function langSwitcherSelect() {
	document.location.href = window.location.pathname.replace(/^\/(en\/|ua\/)?/i, "/" + this.value) + window.location.search;
}
;function is_ipad() {
	return navigator.userAgent.match(/iPad/i) && !navigator.userAgent.match(/Chrome/i);
}

function is_android() {
	return /android/i.test(navigator.userAgent || navigator.vendor || window.opera);
}

function is_ios() {
	return /(iPad|iPhone|iPod)/i.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream;
}

function is_ios_desktop() {
	return /(os x|apple|mac os)/i.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream;
}

function is_retina() {
	var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)";
	if (window.devicePixelRatio > 1)
		return true;
	if (window.matchMedia && window.matchMedia(mediaQuery).matches)
		return true;
	return false;
}

function is_mobile() {
	return ($(window).width() <= 480) || $('body').hasClass('mobile');
}
;var ani_cnt_i = 0;
var ani_cnt_i2 = 2;
var ani_cnt_i3 = 0;

$(window).on('resize scroll', function () {
	if ($('#step14').length) {
		if ($(window).scrollTop() > $('body').height() - $(window).height() - 500) {
			step14_show_more();
		}
	}
});


$(document).ready(function () {

	if ($('#step14').length) {
		window.setTimeout(function () {
			//step14_counters2();
			window.setInterval(step14_counters2, 4000);
			// $('#client_switch').css({opacity:1}).addClass('client_switch_act');
			// if (is_type) {
			//   $('#client_types').removeClass('client_types_on').css({opacity: 0});
			//   window.setTimeout(function() { $('#client_types').css({display: 'none'}); is_type = 0; }, 500);
			// }
		}, 2000);
		// window.setTimeout(function() {
		//   $('#client_switch').removeClass('client_switch_act');
		//   $('#client_types').addClass('client_types_init');
		// }, 3000);

		window.setInterval(step14_counters, 4000);
		$('#load_hidden').load($('#load_hidden').attr('rel') + '?action=load_hidden');

		$('#client_switch').on('click', function () {
			if ($(this).hasClass('client_switch_on')) {
				$(this).removeClass('client_switch_on').prev().html($(this).prev().attr('rel'));
				div_adaptive_collapse();
				window.setTimeout('filter_work(0)', 500);
			}
			if (1) {
				if ($('#client_types').hasClass('client_types_on')) {
					$('#client_types').removeClass('client_types_on').css({opacity: 0});
					window.setTimeout(function () {
						$('#client_types').css({display: 'none'});
					}, 500);
				} else {
					$('#client_types').addClass('client_types_on').css({display: 'block'});
					window.setTimeout(function () {
						$('#client_types').css({opacity: 1});
					}, 100);
				}
				is_type = 1 - is_type;
			}
			return false;
		});
		$('#client_types a').on('click', function () {
			filter_work($(this).attr('rel'));
			$('#client_switch').trigger('click');
			$('#client_switch').addClass('client_switch_on');
			$('#header h1 span.type').html($(this).html());
			return false;
		});
		is_type = 1;
	}
	$('#plan_name a.name').on('click', function () {
		is_plan = 1 - is_plan;
		if (!is_plan) {
			$('#plan_drop').css({height: 0});
			if ($('#step14').length) {
				div_adaptive();
			} else {
				$(window).trigger('scroll');
			}
			$(this).addClass('name_on');
		} else {
			$('#plan_drop').css({height: $('#plan_drop .in').outerHeight()});
			if ($('#step14').length) {
				div_adaptive_collapse();
			} else {
				$('body').removeClass('scr0 scr1 scr2 scr3 scr4 scr5 scr6');
			}
			$(this).removeClass('name_on');
		}
		return false;
	});
});


function step14_counters2() {
	ani_cnt_i2++;
	if (ani_cnt_i2 == 9) ani_cnt_i2 = 1;
	ani_cnt_i3 = 0;
	if (ani_cnt_i2 == 3) ani_cnt_i3 = 1;
	if (ani_cnt_i2 == 5) ani_cnt_i3 = 3;
	if (ani_cnt_i2 == 7) ani_cnt_i3 = 5;
	if (ani_cnt_i2 == 1) ani_cnt_i3 = 7;
	if (ani_cnt_i2 == 4) ani_cnt_i3 = 2;
	if (ani_cnt_i2 == 6) ani_cnt_i3 = 4;
	if (ani_cnt_i2 == 8) ani_cnt_i3 = 6;
	if (ani_cnt_i2 == 2) ani_cnt_i3 = 8;
	if (ani_cnt_i3 % 2 == 1) {
		$('#step14 .head .l .ico_pl').removeClass('ico_pl_co');
	} else {
		$('#step14 .head .r .ico_pl').removeClass('ico_pl_co');
	}
}

function step14_counters() {
	ani_cnt_i = 0;
	$('#step14 .head .a' + ani_cnt_i3).css({opacity: 0});
	$('#step14 .head .a' + ani_cnt_i2).css({opacity: 1}).find('.ani_count').addClass('ani_count_start');
	if (ani_cnt_i2 % 2 == 1) {
		$('#step14 .head .l .ico_pl').attr('class', 'ico_pl ico_pl_co ico_pl' + ani_cnt_i2);
	} else {
		$('#step14 .head .r .ico_pl').attr('class', 'ico_pl ico_pl_co ico_pl' + ani_cnt_i2);
	}
}